<template lang="pug">
  .part.part-6
    .game__title
      p 你的心跳是 #[span(v-if="author") {{ author.bpm }}]bpm#[br]最後一步，為單曲上傳封面吧!
    .game__canvas
      iframe.game__canvas__iframe(
        src="./animation/heart/index.html",
        allowtransparency="true",
        scrolling="no",
        frameborder="0"
        :class="{'game__canvas__iframe--loaded': isIframeLoaded}"
        @load="iframeOnLoad"
      )
    //- a.game__button.game__button--upload(href="#" @click.prevent="changePart(7)")
    a.game__button.game__button--ai(href="#" @click.prevent="changePart(7); $trackEvent('step4', 'click_button', 'step4_aiupload');")
      span AI 生成單曲封面
    a.game__button.game__button--upload(href="#" @click.prevent="$refs.file.click(); $trackEvent('step4', 'click_button', 'step4_upload');")
      span 自己上傳單曲封面
    .game__note
      p *限5MB以內JPG檔案
    input.game__file(type="file" ref="file" accept="image/jpeg" @change="handleImage" style="display: none;")
    .game__cover
      .game__cover__image(:style="`background-image: url(${image});`" ref="screenshot")
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { mixins } from '@/utils/mixins'
import html2canvas from 'html2canvas';

export default {
  name: 'GamePart6',
  mixins: [mixins],
  props: {
    changePart: Function,
  },
  data: () => {
    return {
      isIframeLoaded: false,
      image: '',
      base64: '',
    }
  },
  computed: {
    ...mapState(['author'])
  },
  methods: {
    ...mapActions(['saveAuthor']),
    iframeOnLoad() {
      this.isIframeLoaded = true;
    },
    handleImage(e) {
      const { files } = this.$refs.file;
      if (files.length <= 0) return;
      const selectedImage = files[0];
      const imageSize = selectedImage.size;
      const imageSizeToMb = imageSize / 1024 ** 2;
      if (imageSizeToMb >= 5) {
        this.$toast.error('圖片不符合規定，重新上傳 5MB 以內的 JPG 檔案吧！');
        return;
      }
      this.createBase64Image(selectedImage);
    },
    createBase64Image(file) {
      const { convertHtmlToCanvas } = this;
      const reader = new FileReader();
      reader.onloadend = () => {
        this.image = reader.result;
        this.$nextTick(() => {
          convertHtmlToCanvas();
        })
      }
      reader.readAsDataURL(file);
    },
    convertHtmlToCanvas() {
      const { author, saveAuthor, changePart } = this;
      const { screenshot } = this.$refs;
      html2canvas(
        screenshot,
        {
          backgroundColor: 'rgba(0,0,0,0)',
        }
      ).then((canvas) => {
        this.base64 = canvas.toDataURL('image/jpeg');
        saveAuthor({...author, cover: this.base64});
        changePart(7);
      });
    }
  },
  mounted() {
    this.$trackPage('step4');
  },
  components: {
  }
}
</script>

<style lang="scss">

$assets: '~@/assets/images/game/part-6/';

#game .part-6 {

  .game__title {
    position: absolute;
    top: vw(263);
    left: 0;
    width: 100%;
    z-index: 1;
    p {
      font-size: vw(30);
      text-align: center;
      line-height: vw(60);
      letter-spacing: vw(letterSpacing(500, 30));
      padding-left: vw(letterSpacing(500, 30));
      @include narrow-text;
      @include neon-text;
    }
    span {
      font-size: vw(55);
    }
  }

  .game__canvas {
    position: absolute;
    top: vw(315);
    left: 0;
    width: vw(750);
    height: vw(750);
    background: none;
    // background: #000;
    .game__canvas__iframe {
      display: block;
      width: 100%;
      height: 100%;
      opacity: 0;
      transform: scale(1.3);
      transition: .85s ease .15s;
      transition-property: opacity, transform;
      &--loaded {
        opacity: 1;
        transform: scale(1);
      }
    }
  }

  .game__button {
    width: vw(324);
    min-width: 0;
    padding-bottom: vw(5);
    span {
      letter-spacing: vw(letterSpacing(200, 30));
      text-indent: vw(letterSpacing(200, 30));
    }
  }

  .game__button--ai {
    top: vw(1018);
    left: vw(39);
  }

  .game__button--upload {
    top: vw(1018);
    left: vw(383);
  }

  .game__note {
    position: absolute;
    top: vw(1100);
    left: vw(412);
    // width: 100%;
    p {
      font-size: vw(22);
      font-weight: 500;
      text-align: center;
      letter-spacing: vw(letterSpacing(300, 22));
      text-indent: vw(letterSpacing(300, 22));
      @include narrow-text;
      transform-origin: left top;
    }
  }

  .game__cover {
    position: fixed;
    top: 0;
    left: 0;
    width: 0;
    height: 0;
    pointer-events: none;
    overflow: hidden;
    opacity: 0;
    &__image {
      width: vw(1000);
      height: vw(1000);
      background-position: center center;
      background-repeat: no-repeat;
      background-size: cover;
    }
  }

}

</style>
